const Menu = (state = true, action) => {
    switch (action.type) {
        case  'MENU_TOGGLE':
            return action.payload;
    }
    return state
}

export default Menu;



// WEBPACK FOOTER //
// ./src/reducers/Menu.js